import { SUPPORTED_REPORTS } from "../../data/constant";

const isReportDetailSupported = (reportClass) => {
  return SUPPORTED_REPORTS.includes(reportClass);
};

export default isReportDetailSupported;
